var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.place && !_vm.loading
        ? _c(
            "div",
            [
              _c("page-title-area", [
                _c("h1", [_vm._v(_vm._s(_vm.place.name))]),
              ]),
              _vm._v(" "),
              _vm.currentFloorPlan
                ? _c("floor-plan-toolbar", {
                    staticClass: "floor-plan-toolbar",
                    attrs: {
                      "current-floor-plan": _vm.currentFloorPlan,
                      "all-floor-plans": _vm.allFloorPlans,
                      "selected-month": _vm.selectedMonth,
                      "insect-filter": _vm.selectedInsectFilter,
                      "display-mode": _vm.displayMode,
                      "loading-events": _vm.loadingEvents,
                      "has-unsaved-changes": _vm.hasUnsavedChanges,
                      deleting: _vm.deleting,
                      saving: _vm.saving,
                      exporting: _vm.exporting,
                    },
                    on: {
                      change: _vm.handleFloorPlanSwitch,
                      "save-name": _vm.handleSaveName,
                      save: _vm.saveChanges,
                      cancel: _vm.cancelChanges,
                      add: _vm.handleAdd,
                      delete: _vm.handleDelete,
                      download: _vm.handleDownload,
                      "month-change": _vm.handleMonthChange,
                      "insect-filter-change": _vm.handleInsectFilterChange,
                      "display-mode-change": function ($event) {
                        _vm.displayMode = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: {
                  type: "file",
                  accept: ".jpg,.jpeg,.png",
                  "aria-label": _vm.$t("aria.floor_plan_file_input"),
                },
                on: { change: _vm.handleFileSelected },
              }),
              _vm._v(" "),
              _vm.isUploadingFloorPlan
                ? _c(
                    "v-alert",
                    { staticClass: "mb-4", attrs: { type: "info", dense: "" } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("msg.upload_processing")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentFloorPlan
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "8" } },
                        [
                          _c("floor-plan-canvas", {
                            ref: "floorPlanCanvas",
                            attrs: {
                              "floor-plan": _vm.currentFloorPlan,
                              traps: _vm.trapList,
                              "display-mode": _vm.displayMode,
                              "place-name": _vm.place ? _vm.place.name : "",
                              "selected-month": _vm.selectedMonth,
                              "insect-filter-label": _vm.getInsectFilterLabel(),
                            },
                            on: { change: _vm.handleFloorPlanChange },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _vm.currentFloorPlan
                            ? _c("trap-panel", {
                                key: _vm.currentFloorPlan.id,
                                attrs: {
                                  traps: _vm.trapList,
                                  events: _vm.events,
                                  "place-name": _vm.place ? _vm.place.name : "",
                                  "floor-plan-name": _vm.currentFloorPlan
                                    ? _vm.currentFloorPlan.name
                                    : "",
                                  "selected-month": _vm.selectedMonth,
                                  "insect-filter-label":
                                    _vm.getInsectFilterLabel(),
                                },
                                on: { remove: _vm.handleRemoveTrap },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : !_vm.isUploadingFloorPlan
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "text-center pa-8" },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    size: "80",
                                    color: "grey lighten-1",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            mdi-floor-plan\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("h2", { staticClass: "mt-4 mb-2" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("empty.title")) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text--secondary mb-4" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("empty.description")) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", large: "" },
                                  on: { click: _vm.handleAdd },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v(
                                      "\n              mdi-upload\n            "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("empty.upload_button")) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c("page-load-spinner"),
      _vm._v(" "),
      _vm.pollingForNewFloorPlan
        ? _c("polling-channel", {
            attrs: {
              input: _vm.pollingState,
              active: _vm.pollingForNewFloorPlan,
              updateFunction: _vm.checkForNewFloorPlan,
              interval: _vm.POLLING_INTERVAL_MS,
            },
            on: { valueUpdated: _vm.onFloorPlanPollingUpdate },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }